import { BaseLinkButton } from "@rikstv/shared-components";
import { FC } from "react";
import Icon from "../icons/Icon";
import classes from './ChevronToggleButton.module.css';

export const ChevronToggleButton: FC<{toggledOn: boolean, onClick: () => void, showMoreText?: string, showLessText?: string}> = ({
  onClick,
  toggledOn,
  showMoreText = 'Vis mer',
  showLessText = 'Vis mindre'
}) => {

  return (
    <BaseLinkButton className={classes.chevronToggleButton} onClick={onClick} element="button" buttonStyle={'highlighted'}>
      {toggledOn ? showLessText : showMoreText}
      <Icon flip={toggledOn ? 'vertical' : undefined} type="chevron" />
    </BaseLinkButton>
  )
}